<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-11 16:24:41
-->
<template>
  <div class="page-list">
    <!-- 实时存塘量 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item date-selection-box">
          <span @click="param.params.type = 'Y'" :class="[param.params.type == 'Y' ? 'active-date' : '']">年</span>
          <span @click="param.params.type = 'M'" :class="[param.params.type == 'M' ? 'active-date' : '']">月</span>
        </div>
        <div class="page-search-item" v-if="param.params.type === 'Y'">
          <label>年份&nbsp;:</label>
          <el-date-picker :picker-options="pickerOptions" key="year" value-format="yyyy" v-model="param.params.year"
            type="year" placeholder="请选择年份">
          </el-date-picker>
        </div>
        <div class="page-search-item" v-if="param.params.type === 'M'">
          <label>月份区间&nbsp;:</label>
          <el-date-picker v-model="date" :picker-options="pickerOptions" key="month" type="monthrange" range-separator="~"
            start-placeholder="开始月份" end-placeholder="结束月份">
            >
          </el-date-picker>
        </div>
        <div class="page-search-item">
          <label>公司&nbsp;:</label>
          <el-select v-model="param.params.orgId" placeholder="请选择公司">
            <el-option label="全部公司" value=""></el-option>
            <el-option :key="index" v-for="(item, index) in GongSiList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>造次&nbsp;:</label>
          <el-select v-model="param.params.periodId" placeholder="请选择批次">
            <el-option label="全部造次" value=""></el-option>
            <el-option :key="index" v-for="(item, index) in PiCiList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品类&nbsp;:</label>
          <el-select v-model="param.params.breedTypeId" placeholder="请选择品类">
            <el-option label="全部品类" value=""></el-option>
            <el-option :key="index" v-for="(item, index) in PinLeiList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品种&nbsp;:</label>
          <el-select v-model="param.params.breedId" placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option :key="index" v-for="(item, index) in PinZhongList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="pageSearch">查询</div>
        <div class="reset-btn" @click="reSet">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="page-list-content">
      <div class="page-list-title">
        <div><i class="title-icon"></i>各公司养成结转成本统计表</div>
        <div>单位 : {{ tableTitle }}</div>
        <div v-if="param.params.type === 'Y'">年份 : {{ tableDate }}年</div>
        <div v-if="param.params.type === 'M'">月份 : {{ tableDate }}</div>
        <div>
          <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span @click="doExport">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :row-class-name="tableRowClassName"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="orgName" label="单位名称"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="periodName" label="养殖造次"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="品类"></el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"></el-table-column>
        <el-table-column label="变动成本">
          <el-table-column label="投苗情况">
            <el-table-column prop="putNumberSeed" label="数量(尾)"></el-table-column>
            <el-table-column prop="putMoneySeed" label="金额"></el-table-column>
          </el-table-column>
          <el-table-column label="饲料">
            <el-table-column prop="putNumberFodd" :label="'数量(' + fodderKgToJin + ')'"></el-table-column>
            <el-table-column prop="putMoneyFodd" label="金额"></el-table-column>
          </el-table-column>
          <el-table-column prop="putMoneyDrug" label="动保"></el-table-column>
          <el-table-column prop="electricCost" label="电费"></el-table-column>
          <el-table-column prop="artificialCost" label="人工"></el-table-column>
          <el-table-column prop="consumablesCost" label="低值易耗品"></el-table-column>
          <el-table-column prop="netCost" label="拉网费"></el-table-column>
          <el-table-column prop="deprecitCost" label="折旧与摊销"></el-table-column>
          <el-table-column prop="repairCost" label="修理费"></el-table-column>
          <el-table-column prop="fuelFee" label="燃料"></el-table-column>
          <el-table-column prop="rentalFee" label="租赁费"></el-table-column>
          <el-table-column prop="otherFee" label="其他公摊"></el-table-column>
        </el-table-column>
        <el-table-column label="定额费用">
          <el-table-column prop="oldFee" label="网箱折旧"></el-table-column>
          <el-table-column prop="manageFee" label="管理费"></el-table-column>
          <el-table-column prop="seaAreaFee" label="海域费"></el-table-column>
          <el-table-column prop="rentPondFee" label="塘租"></el-table-column>
        </el-table-column>
        <el-table-column prop="total" label="成本合计"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Page from "@/utils/methods/page";
import {
  initPageList,
  getAllJiGou,
  getAllPiCi,
  getAllPinLei,
  getAllPinZhong,
} from "./yc-cost-services";
import { listParamStatus } from "@/api/general.js";
export default {
  name: "yc",
  data() {
    return {
      pickerOptions: {
        // 超出当前年份或月份不可选
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      tableTitle: "",
      tableDate: "",
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "orgName",
          fixed: false,
          selected: false
        },
        {
          prop: "periodName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      param: {
        currPage: 1, //第几页
        pageSize: 10, //每页条数
        // orderBy: "desc",//排序
        // orderByName: "org_name",//排序字段
        params: {
          rootOrgId: localStorage.getItem("rootId"), //顶级机构id（公司）
          orgId: "", //机构id（公司）
          breedTypeId: "", //养殖造次id
          periodId: "", //育苗批次id
          seedlingDataId: "", //养殖品类
          breedId: "", //养殖品种id
          type: "Y", //时间查询类型 Y年 M月
          startDate: "", //开始时间 月
          endDate: "", //结束时间 月
          year: localStorage.getItem("year") ? localStorage.getItem("year") : Page.getCurrentYear(), //年
          breedTypeClass: "fish", //分页查询类型 egg育苗 fish养成
        },
      },
      date: null, //月份区间双向绑定数据
      dateSelectNum: 1,
      PageDisplay: true,
      value: "",
      tableData: [],
      GongSiList: [], //公司下拉数据
      PiCiList: [], //造次下拉数据
      PinLeiList: [], //品类下拉数据
      PinZhongList: [], //品种下拉数据
      fodderKgToJin: '公斤'   // 是否把公斤转换成斤
    };
  },
  computed: {},
  created() {
    this.tableHeight = window.innerHeight - 400;
  },
  mounted() {
    // 模板编译/挂载之后
    this.initPage(this.param);
    this.getAllSearchSelect();
    Page.pagesTableFixed();
    // 获取是否公斤转换成斤
    listParamStatus(this.param.params.rootOrgId, ['fodderKgToJin']).then((res) => {
      if (res.code == "0000") {
        this.fodderKgToJin = res.data.fodderKgToJin === true ? '斤' : '公斤';
      }
    })
  },
  methods: {
    doExport() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(async () => {
          const param = {
            rootOrgId: this.param.params.rootOrgId,
            orgId: this.param.params.orgId,
            breedTypeId: this.param.params.breedTypeId,
            periodId: this.param.params.periodId,
            seedlingDataId: this.param.params.seedlingDataId,
            breedId: this.param.params.breedId,
            type: this.param.params.type,
            startDate: this.param.params.startDate,
            endDate: this.param.params.endDate,
            year: this.param.params.year,
            breedTypeClass: "fish",
            fileName: "养成-成本概览报表",
          };
          const flag = await Page.exportDatas(
            "/outSaleCostOrg/exportOutSaleCostOrgList",
            param
          );
        })
        .catch(() => { });
    },
    // 获取所有下拉选择项
    getAllSearchSelect() {
      let rootId = localStorage.getItem("rootId");
      Promise.all([
        getAllJiGou(rootId),
        getAllPiCi(rootId),
        getAllPinLei(rootId),
        getAllPinZhong(rootId),
      ])
        .then((result) => {
          const [JiGouData, PiCiData, PinLeiData, PinZhongData] = result;
          this.GongSiList = JiGouData.data;
          this.PiCiList = PiCiData.data;
          this.PinLeiList = PinLeiData.data;
          this.PinZhongList = PinZhongData.data;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.orgName === "合计") {
        return "heji-row";
      }
    },
    initPage(data) {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      initPageList(data).then((res) => {
        this.tableTitle = Page.orgIdFilter(data.params.orgId, this.GongSiList);
        if (data.params.type === "Y") {
          this.tableDate = data.params.year;
        } else {
          this.tableDate = Page.IntervalMonthFilter(
            data.params.startDate,
            data.params.endDate
          );
        }
        this.tableData = res.data.list;
        setTimeout(() => {
          loading.close();
        }, 0);
      });
    },
    reSet() {
      this.param = {
        currPage: 1, //第几页
        pageSize: 10, //每页条数
        // orderBy: "desc",//排序
        // orderByName: "org_name",//排序字段
        params: {
          rootOrgId: localStorage.getItem("rootId"), //顶级机构id（公司）
          orgId: "", //机构id（公司）
          breedTypeId: "", //养殖造次id
          periodId: "", //育苗批次id
          seedlingDataId: "", //养殖品类
          breedId: "", //养殖品种id
          type: "Y", //时间查询类型 Y年 M月
          startDate: "", //开始时间 月
          endDate: "", //结束时间 月
          year: localStorage.getItem("year") ? localStorage.getItem("year") : Page.getCurrentYear(), //年
          breedTypeClass: "fish", //分页查询类型 egg育苗 fish养成
        },
      };
      this.initPage(this.param);
    },
    // 查询按钮
    pageSearch() {
      this.initPage(this.param);
    },
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    PageSearchOn() {
      Page.PageSearchOn(this);
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  // 数据监听
  watch: {
    date: function (newVal, oldVal) {
      if (newVal) {
        const [date1, date2] = newVal;
        const startMonth = Page.getCurrentMonth(date1);
        const endMonth = Page.getCurrentMonth(date2);
        this.param.params.startDate = startMonth;
        this.param.params.endDate = endMonth;
      }
    },
    "param.params.type": function (newVal, oldVal) {
      if (newVal === "Y") {
        this.param.params.startDate = null;
        this.param.params.endDate = null;
        this.date = null;
        this.param.params.year = localStorage.getItem("year") ? localStorage.getItem("year") : Page.getCurrentYear();
        this.initPage(this.param);
        return;
      }
      this.param.params.year = null;
      const Timer = new Date();
      this.date = [Timer, Timer]; //给到当前年月-显示在日期区间选择框内
      this.param.params.startDate = Page.getCurrentMonth();
      this.param.params.endDate = Page.getCurrentMonth();
      this.initPage(this.param);
    },
  },
};
</script>

<style lang="less" scoped></style>